module.exports = __webpack_public_path__ + "static/img/7.9c75cfa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/sp/7.png
// module id = cp3A
// module chunks = 0